import { Component } from '@angular/core';

@Component({
    selector: 'app-empty',
    template: '',
    styleUrls: [],
})
export class EmptyComponent {

}
